import { trendingNews } from "../../data/resourcesData";
import { Link } from "react-router-dom";
import ResourceHero from "./ResourceHero";
import "../../css/TrendingNews.css";
export default function TrendingNews() {
  return (
    <>
      <ResourceHero
        title="TrendingNews"
        subtitle="Stay updated with the latest educational insights, school news, learning tips, and inspiring stories from our community."
        image="/images/Education_Funds2.png"
      />
      <section className="resources-section" id="trending-news">
        <h2 className="resources-heading">Trending News</h2>

        <div className="resources-card-grid">
          {trendingNews.map((news, index) => (
            <a href={news.href} key={index} className="resources-news-card">
              <img
                src={news.image}
                alt={news.title}
                className="resources-news-image"
              />

              <div className="resources-meta">
                <span>{news.author}</span>
                <span>{news.date}</span>
              </div>

              <h3>{news.title}</h3>

              <p>{news.excerpt}</p>

              
            </a>
          ))}
        </div>
      </section>
      {}

      <section className="news-highlight-section">
        <div className="container highlight-wrapper">
          <div className="highlight-content">
            <span>Latest Highlights</span>

            <h2>Stay Connected With What's Happening</h2>

            <p>
              Keep up with the latest happenings at Sahara Public School. From
              academic achievements and student success stories to competitions,
              events and important announcements, our news section keeps parents
              and students informed.
            </p>

            <ul>
              <li>School Events & Celebrations</li>

              <li>Academic Achievements</li>

              <li>Competition Results</li>

              <li>Community Outreach Programs</li>

              <li>Important School Announcements</li>
            </ul>
          </div>

          <div className="highlight-image">
            <img src="./images/l.jpeg" alt="School News" />
          </div>
        </div>
      </section>
      {}

      <section className="news-category-section">
        <div className="container">
          <div className="section-heading">
            <span>Browse More</span>

            <h2>News Categories</h2>

            <p>
              Explore the latest updates across academics, events, sports and
              student achievements.
            </p>
          </div>

          <div className="news-category-grid">
            <div className="news-category-card">
              <h3>Academic News</h3>
              <p>Curriculum updates, examinations and classroom activities.</p>
            </div>

            <div className="news-category-card">
              <h3>School Events</h3>
              <p>Annual functions, cultural events and celebrations.</p>
            </div>

            <div className="news-category-card">
              <h3>Sports Updates</h3>
              <p>Inter-school competitions and sporting achievements.</p>
            </div>

            <div className="news-category-card">
              <h3>Student Achievements</h3>
              <p>Awards, recognitions and outstanding performances.</p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
